import type { AxiosInstance } from 'axios';
import { messageFor } from '../error-message';

/**
 * Attaches a `normalised` view of every failed request. `message` is the line a
 * page shows — worked out once here rather than in each page's own copy, and
 * never Axios's raw text ("Network Error", "timeout of 15000ms exceeded").
 * Pages read it through `extractErr`.
 */
export function errorInterceptor(api: AxiosInstance): void {
  api.interceptors.response.use(
    (resp) => resp,
    (error) => {
      const data = error?.response?.data ?? {};
      const normalised = {
        code: data.code ?? 'UNKNOWN',
        message: messageFor(error),
        correlationId: data.correlationId ?? error?.response?.headers?.['x-correlation-id'],
        details: data.details,
      };
      return Promise.reject(Object.assign(error, { normalised }));
    },
  );
}
